import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Search } from 'semantic-ui-react';

const propTypes = {
  // State
  searchText: PropTypes.string.isRequired,
  suggestions: PropTypes.arrayOf(PropTypes.shape).isRequired,

  // Dispatch
  updateSearchText: PropTypes.func.isRequired,
  activateResourceSearch: PropTypes.func,
};

const defaultProps = {
  activateResourceSearch: undefined,
};

class CustomSearch extends Component {
  constructor(props) {
    super(props);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleResultSelect = this.handleResultSelect.bind(this);
  }

  componentWillMount() {
    this.resetComponent();
  }

  componentDidMount() {
    // Set up regular "enter" search, rather than using suggestion
    document.getElementById('search').addEventListener('keydown', (event) => {
      if (event.keyCode === 13) {
        if (this.searchState().selectedIndex < 0) {
          document.getElementById('search').blur();
          this.props.activateResourceSearch({});
        }
      }
    });
  }

  resetComponent() {
    return this.setState({
      loading: false,
    });
  }

  handleSearchChange(e, { value }) {
    this.props.updateSearchText({
      searchText: value,
    });
  }

  handleResultSelect(e, { result }) {
    window.scrollTo(0, 0);
    this.props.activateResourceSearch({
      searchText: result.value,
      results: result.results,
    });
  }

  render() {
    const { loading } = this.state;
    const { searchText, suggestions } = this.props;
    return (
      <Search
        fluid
        id="search"
        size="large"
        placeholder="Search..."
        onFocus={(e, data) => {
          this.handleSearchChange(e, data);
          const searchInput = document.getElementById('search');
          const cursorAt = searchInput.value.length;
          setTimeout(() => {
            searchInput.setSelectionRange(cursorAt, cursorAt);
          }, 1);
        }}
        value={searchText}
        loading={loading}
        minCharacters={0}
        results={suggestions.map(tag => ({
          ...tag,
          key: tag._id,
          resources: tag.results,
        }))}
        showNoResults={false}
        onSearchChange={this.handleSearchChange}
        ref={(search) => { this.searchState = search ? () => search.state : undefined; }}
        onResultSelect={this.handleResultSelect}
        resultRenderer={({ suggestionText, resources }) => (
          <div>
            <p style={{ float: 'left', marginTop: 0, marginBottom: 0 }}>{suggestionText}</p>
            <p style={{
              float: 'right',
              marginTop: 0,
              marginBottom: 0,
              fontStyle: 'italic',
            }}
            >{`${resources.length} result${resources.length === 1 ? '' : 's'}`}</p>
          </div>
        )}
      />
    );
  }
}
CustomSearch.propTypes = propTypes;
CustomSearch.defaultProps = defaultProps;

export default CustomSearch;



// WEBPACK FOOTER //
// ./src/components/Search.jsx